// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__2qNBI","link":"Breadcrumbs_link__+3kq0","separator":"Breadcrumbs_separator__KpzP+"};